// @flow

const uniqueId = (function () {
    let counter = 0;
    return prefix => `${prefix}-${counter++}`;
})();

type Attributes = { [key: string]: string };
type Data = { [key: string]: any };

function addAttributes(element: HTMLElement, attributes: Attributes = {}) {
    Object.keys(attributes).forEach(attr => {
        const attributeValue = attributes[attr];
        // $FlowFixMe HTMLElement doesn't have indexer
        element[attr] = attributeValue;
    });
}

function appendElementToDOM(element: HTMLElement, baseElement: ?HTMLElement = document.body) {
    if (baseElement) {
        baseElement.appendChild(element);
    }
}

function removeElementFromDOM(element: HTMLElement) {
    if (element.parentNode) {
        element.parentNode.removeChild(element);
    }
}

function setUpForm(url: string, data: Data = {}, attributes: Attributes = {}): HTMLFormElement {
    const form = document.createElement('form');
    form.style.display = 'none';

    addAttributes(form, {
        method: 'post',
        action: url,
        enctype: 'multipart/form-data',
        ...attributes,
    });

    Object.keys(data).forEach(key => {
        const keyValue = data[key];

        let input;
        if (keyValue instanceof window.HTMLInputElement) {
            input = keyValue.cloneNode();
            addAttributes(input, { name: key });
        } else {
            input = document.createElement('input');
            addAttributes(input, {
                type: 'text',
                name: key,
                value: keyValue,
            });
        }

        form.appendChild(input);
    });

    return form;
}

function setUpIframe(attributes: Attributes = {}): HTMLIFrameElement {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    addAttributes(iframe, attributes);
    return iframe;
}

export function post(url: string, data: Data) {
    const form = setUpForm(url, data);
    appendElementToDOM(form);
    form.submit();
}

export function postToIframe(url: string, data: Data): Promise<void> {
    const target = uniqueId('Iframe-Post');
    const iframe = setUpIframe({ name: target });
    const form = setUpForm(url, data, { target });

    appendElementToDOM(iframe);
    appendElementToDOM(form);

    const responsePromise = new Promise(resolve => {
        iframe.onload = () => {
            resolve();
            removeElementFromDOM(iframe);
            removeElementFromDOM(form);
        };
    });
    form.submit();
    return responsePromise;
}

type FakeFormResponse = {|
    readyState: string,
    responseText: string,
    status: string,
|};

export function postFakeForm(url: string = '', data: Data = {}): Promise<FakeFormResponse> {
    return new Promise((resolve, reject) => {
        const fd = new window.FormData();
        Object.keys(data).forEach(key => {
            fd.append(key, data[key]);
        });

        const xhr = new window.XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.onreadystatechange = () => {
            try {
                const { responseText, readyState, status } = xhr;
                resolve({
                    readyState,
                    responseText,
                    status,
                });
            } catch (e) {
                reject(e);
            }
        };

        xhr.send(fd);
    });
}
